import classNames from "classnames"
import { withStyles } from "@material-ui/core"
import React from "react"

const styles = (theme) => ({
    ul: {
        marginTop: theme.spacing(0),
        paddingLeft: theme.spacing(4),
    },
})

const ulMd = ({ classes, className, children }) =>
    <ul children={children} className={classNames(classes.ul, className)}/>;

export const UlMd = withStyles(styles)(ulMd)